<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <p class="text--secondary">
        Тексты, которые сервис отправляет сам. Каждый язык сохраняется своей кнопкой; пустой
        текст возвращает текст по умолчанию.
      </p>

      <div
        v-for="template in templates"
        :key="template.code"
        class="mb-6"
      >
        <v-divider class="mb-4"></v-divider>

        <div class="d-flex align-center flex-wrap">
          <span class="text-subtitle-1 font-weight-medium me-3">{{ template.name }}</span>
          <v-chip
            x-small
            label
          >
            {{ channelName(template.channel) }}
          </v-chip>
        </div>
        <div
          v-if="template.placeholders.length"
          class="text-caption text--secondary"
        >
          В тексте обязательно: {{ placeholders(template) }}
        </div>

        <v-row class="mt-2">
          <v-col
            v-for="text in template.texts"
            :key="text.language"
            cols="12"
            md="4"
          >
            <div class="d-flex align-center mb-2">
              <span class="text-subtitle-2 me-2">{{ languageName(text.language) }}</span>
              <v-chip
                v-if="text.isDefault"
                x-small
              >
                по умолчанию
              </v-chip>
              <span
                v-else
                class="text-caption text--secondary"
              >
                изменён {{ toDateTimeString(text.updatedAt) }}<span v-if="text.updatedBy"> · {{ text.updatedBy }}</span>
              </span>
            </div>

            <v-textarea
              v-model="text.body"
              rows="4"
              auto-grow
              counter
              dense
              outlined
              :error-messages="messages(template, text)"
            ></v-textarea>

            <div
              v-if="isLongSms(template, text)"
              class="text-caption warning--text mb-2"
            >
              длиннее 70 знаков — SMS уйдёт несколькими частями
            </div>

            <v-btn
              color="primary"
              small
              class="me-2"
              :loading="saving === key(template, text)"
              :disabled="hasNotPermission('Permissions.NotificationSettingsUpdate')"
              @click="save(template, text, text.body)"
            >
              Сохранить
            </v-btn>
            <v-btn
              small
              text
              :disabled="isUntouched(text) || hasNotPermission('Permissions.NotificationSettingsUpdate')"
              @click="save(template, text, '')"
            >
              Вернуть текст по умолчанию
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { errorMessages, hasPermission, toDateTimeString } from '@/helpers'
import {
  channelName,
  isSmsChannel,
  languageName,
  templateTextKey,
} from '@/helpers/notifications'

const SMS_PART_LENGTH = 70

const CYRILLIC = /[Ѐ-ӿ]/

export default {
  name: 'TemplateSettingForm',
  data: () => ({
    channelName,
    languageName,
    toDateTimeString,
  }),
  computed: {
    ...mapState('notificationSettings', ['templates', 'saving']),
    ...mapGetters('notificationSettings', ['errorsOf']),
  },
  methods: {
    ...mapActions('notificationSettings', ['updateTemplate']),
    hasNotPermission(value) {
      return !hasPermission(value)
    },
    key(template, text) {
      return templateTextKey(template.code, text.language)
    },
    messages(template, text) {
      return errorMessages(this.errorsOf(this.key(template, text)), 'body')
    },
    placeholders(template) {
      return template.placeholders.map(name => `{${name}}`).join(', ')
    },

    isLongSms(template, text) {
      const body = text.body || ''

      return isSmsChannel(template.channel) && body.length > SMS_PART_LENGTH && CYRILLIC.test(body)
    },

    isUntouched(text) {
      return text.isDefault && text.body === text.defaultBody
    },

    async save(template, text, body) {
      await this.updateTemplate({ code: template.code, language: text.language, body })
    },
  },
}
</script>
